/**
 * IDs de rastreamento fixados no código — carregam sempre, mesmo com o
 * banco de dados pausado. Valores cadastrados no painel administrativo
 * continuam valendo como fallback para IDs não definidos aqui.
 */
export const TRACKING_IDS = {
  gtmId: "GTM-TD9TTL6T",
  ga4Id: null as string | null,
  googleAdsId: "AW-11191774474",
  clarityId: "y9gtg0j8sn",
};
